import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=228efcf8&scoped=true&"
import script from "./SidebarMobile.vue?vue&type=script&setup=true&lang=js&"
export * from "./SidebarMobile.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SidebarMobile.vue?vue&type=style&index=0&id=228efcf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228efcf8",
  null
  
)

export default component.exports